import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderIt = () => {
    return (
        <HighlightedText
            text="GRATTA I BIGLIETTI E OTTIENI IL TUO BONUS"
            highlights={[
                { word: 'OTTIENI' },
                { word: 'IL' },
                { word: 'TUO' },
                { word: 'BONUS' },
            ]}
            breakBeforeWords={['OTTIENI']}
            className={styles.text_header}
        />
    )
}
